import BaseSchemaDrawer from './BaseSchemaDrawer'

class RouteDrawer extends BaseSchemaDrawer {
  initObservers() {}

  getOrCreateMarker(obj, options = {}) {
    if (obj === undefined) {
      return false
    }
    let id = this.getMarketId(obj)
    if (!this._markers[id]) {
      if (obj.popupOptions) {
        options.popupOptions = obj.popupOptions
      }
      this._markers[id] = this.markerCreator.getMarker(obj, id, options)
      if (obj.tooltip || obj.name) {
        this._markers[id].bindTooltip(obj.tooltip || obj.name)
      }
    }
    return this._markers[id]
  }
}

export default RouteDrawer
